module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer019"
    }
  }, [_c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Fuck it.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Okay,” I said, finally. “I’ll do it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We’d had this conversation dozens of times. One hundred, more like.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’ll tell me everything?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I had relived it often enough inside my head, inside my dreams, like irresolute images projected onto a filthy window pane, never there, but never really gone. Razor wire insinuated itself around my heart and pulled tight.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“The best that I can remember,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Time sometimes has a way of blunting sharp edges, altering both shadow and light until it dulls to a soft-focus surrogate for reality. This was different. Time had turned this to chiaroscuro.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I had tried. And that simple fact made it all the worse, for in trying I had failed. Perhaps that wasn’t the whole truth; what was that anyway? But it felt like the truth, or something as near to it as I could ever know.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My eyes cut sideways, out the narrow slit of window, and fixed on the gray sky. Clouds had been gathering since late last night, and the wind had begun to push them across the horizon with increasing speed. There would be rain, and soon.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There are things we tell ourselves we need to know, and the longer the desire goes unsatisfied, the more rapidly it metastasizes into a psychic tumor of obsession. These are the things that deprive us of sleep, eventually invade our dreams and swell to unbearable proportions until the seeking becomes an end in itself. The great irony is that once learned, the object of that fixation vanishes and becomes instead a black hole where no comfort is derived from the achievement of the aim we had sought, had expected, or even deserved—the knowledge no less a poison than the obsession had been.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“When?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Now,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I was ready to tell it. As ready as I ever would be.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79750bdd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504082006-2.vue
// module id = 81
// module chunks = 0